$.fn.equalHeights = (tag)->
  currentTallest = 0
  $(@).children(tag).each (i)->
    currentTallest = $(@).height() if $(this).height() > currentTallest
  currentTallest = currentTallest+"px"
  $(@).children(tag).css 'min-height': currentTallest

overlay_box = ->
  # Funzione che muove le immagini della photo gallery
  # IMPORTANTE!! Funziona solo su classe .image-overlay
  $fPhoto = $('.image-overlay').parent()
  $fPhoto.css 'background-color','#000000'
  $('.zoom-icon, .more-icon').css
    'opacity':'0'
    'visibility':'visible'

  $hPhoto = $fPhoto.height()
  $top = ($hPhoto-46)/2
  $($fPhoto).find('a.zoom-icon').css 'top', $top
  $($fPhoto).find('a.more-icon').css 'top', $top

  $wPhoto = $fPhoto.width()
  $zoom_left = ($wPhoto-100)/2
  $more_left = $zoom_left+52
  $($fPhoto).find('a.zoom-icon').css 'left', $zoom_left
  $($fPhoto).find('a.more-icon').css 'left', $more_left

  $fPhoto.hover ->
    $(@).stop(true, true).animate({top: -10}, 500).find('img').stop(true, true).animate({opacity: 0.7}, 500)
    $(@).find('.zoom-icon').stop(true, true).animate({opacity: 1, left: $zoom_left}, 400)
    $(@).find('.more-icon').stop(true, true).animate({opacity: 1, left: $more_left}, 400)
  , ->
    $(@).find('.zoom-icon').stop(true, true).animate({opacity: 0, left: $zoom_left}, 400)
    $(@).find('.more-icon').stop(true, true).animate({opacity: 0, left: $more_left}, 400)
    $(@).stop(true, true).animate({top: 0}, 500).find('img').stop(true, true).animate({opacity: 1}, 500)

pg_nav = ->
  $(".pg-next").hover ->
    $(".pg-prev").animate({marginRight: "774px"}, 250)
    $(@).animate({opacity: .5}, 250)
  , ->
    $(".pg-prev").stop(true, true).animate({marginRight: "769px"}, 250)
    $(@).animate({opacity: 1}, 250)

  $(".pg-prev").hover ->
    $(@).animate({marginLeft: "75px", marginRight: "774px", opacity: .5}, 250)
  , ->
    $(@).stop(true, true).animate({marginLeft: "80px", marginRight: "769px",  opacity: 1}, 250)

center_img_o = (obj,nh)->
  w = obj.width()
  ml = Math.ceil((w-nh)/2)
  ml = ml*-1;
  ml1 = ml+'px';
  obj.css 'marginLeft' : ml1

center_img_v = (obj,nh)->
  h = obj.height()
  mt = Math.ceil((h-nh)/2)
  mt = mt*-1
  mt1 = mt+'px'
  obj.css 'marginTop' : mt1

$ ->
  slideshow()

  $('#games-bar').jcarousel
    vertical: false
    animation: 500
    scroll: 1
    buttonPrevHTML: '<div class="jcarousel-prev jcarousel-prev-horizontal" style="display: block;" disabled="disabled">&lang;</div>'
    buttonNextHTML: '<div class="jcarousel-next jcarousel-next-horizontal" style="display: block;" disabled="disabled">&rang;</div>'

  $('#matches-bar').jcarousel
    vertical: false
    animation: 500
    scroll: 1
    buttonPrevHTML: '<div class="jcarousel-prev jcarousel-prev-horizontal" style="display: block;" disabled="disabled">&lang;</div>'
    buttonNextHTML: '<div class="jcarousel-next jcarousel-next-horizontal" style="display: block;" disabled="disabled">&rang;</div>'

  events_all_page = $('.events-all-page')
  if events_all_page.length > 0

    nLi = $('#events-all li').length
    wUl = (nLi*226)
    $('#events-all').css('width',wUl+'px')

    $('#events-all li').each ->
      img = $(@).find('img')
      img.load ->
        if img.height() < 244
          pTop = Math.floor(244-img.height())/2
          hLink = 246 - pTop
          img.parent('a').css('paddingTop',pTop+'px').css('height',hLink+'px')

    data_json = $('#events-all').data().data_json
    argsCarouselEvents = new Array(3)
    argsCarouselEvents.prevText = data_json.prevText
    argsCarouselEvents.nextText = data_json.nextText
    argsCarouselEvents.todayText = data_json.todayText
    argsCarouselEvents.selector = '#events-all'
    selectedClass = data_json.selectedClass
    normalClass = data_json.normalClass
    carouselEventsAll(data_json.startPoint, argsCarouselEvents)

  $("form#search-media").submit (e)->
    removeDefaultValueOnSubmit(@)

  toggle_default_text('#search-query')
  toggle_default_text('#comment')

  zIndexNumber = 1000
  $('#header div, #c-top div').each ->
    $(@).css('zIndex', zIndexNumber)
    zIndexNumber -= 10

  $('.sf-menu').superfish({autoArrows: false, speed: 'fast', dropShadows: 'true'})
  overlay_box()
  pg_nav()

  # $('.h-l-event-imgwrap').each ->
  #   img = $(@).find('img')
  #   img.load ->
  #     h = $(@).height()
  #     w = $(@).width()
  #     if h > w
  #       $(@).css('width','50px')
  #       m = (h*50)/w
  #       m = Math.ceil((m-50)/2)
  #       m = m*-1
  #       m = m+"px"
  #       $(@).css('marginTop',m)
  #     else
  #       $(@).css('height','50px')
  #       m = (w*50)/h
  #       m = Math.ceil((m-50)/2)
  #       m = m*-1
  #       m = m+"px"
  #       $(@).css('marginLeft',m)

  $('.eq').equalHeights('div')
  $(window).load ->
    center_img_v $('#box-info-item-shop'), 226
    $('.eq').equalHeights('div')

  jCarouselAutoInit('.matches,.games',{
    vertical: false,
    animation: 500,
    scroll: 1,
    buttonPrevHTML: '<div class="jcarousel-prev jcarousel-prev-horizontal" style="display: block;" disabled="disabled">&lang;</div>',
    buttonNextHTML: '<div class="jcarousel-next jcarousel-next-horizontal" style="display: block;" disabled="disabled">&rang;</div>'
  })

  $('*[data-create-onclick]').on "click", (e)->
    parent = $(@).data('create-onclick')
    $link = $(@).parents("li").find('a')
    $link[0].click() if $link[0]

  $('#privacy-policy h3').addClass('box-title')

# Composer
$ ->
  if typeof wp != "undefined" and  wp.customize
    wp.customize "header", (value)->
      value.bind (newval)->
        if newval==""
          $("#wrap-header img").hide()
          $("#wrap-header table").show()
        else
          $("#wrap-header img").show()
          $("#wrap-header table").hide()
          $("#wrap-header img").attr('src', newval)

  $('#m-right .tabs ul li').on "click", ->
    list = $(@)
    content = list.data('content')
    if content? and $(".tab-content##{content}").length == 1
      $('.tab-content').hide()
      $(".tab-content##{content}").show()
      $('#m-right .tabs ul li').removeClass('selected')
      list.addClass('selected')

  if $("#ta_login_box").length == 1 and $("#ta_login_box").parents("#wrapper").length == 0
    $("#ta_login_box").wrap("<div id='wrapper'>")

window.htmltorgb = (hex)->
  hex = hex.replace(/^\s*#|\s*$/g, '')
  if hex.length == 3
    hex = hex.replace(/(.)/g, '$1$1')
  r = parseInt(hex.substr(0, 2), 16)
  g = parseInt(hex.substr(2, 2), 16)
  b = parseInt(hex.substr(4, 2), 16)
  return [r,g,b]

window.alter_brightness = (hex, percent)->
  rgb = htmltorgb(hex)
  r = rgb[0]
  g = rgb[1]
  b = rgb[2]
  return '#' + ((0 | (1 << 8) + r + (256 - r) * percent / 100).toString(16)).substr(1) + ((0 | (1 << 8) + g + (256 - g) * percent / 100).toString(16)).substr(1) + ((0 | (1 << 8) + b + (256 - b) * percent / 100).toString(16)).substr(1)

window.box_background_color2_backend = (newval)->
  _final_color1 = alter_brightness(newval, 7)
  _final_color2 = alter_brightness(newval, 8)
  _final_color3 = alter_brightness(newval, 9)
  _final_color4 = alter_brightness(newval, 13)
  _final_color5 = alter_brightness(newval, 16)
  _style1 = "border-color: #{newval}!important; background: #{_final_color1}; background: -moz-linear-gradient(top, #{_final_color1}, #{_final_color3}); background: -webkit-linear-gradient(top, #{_final_color1}, #{_final_color3}); background: -o-linear-gradient(top, #{_final_color1}, #{_final_color3}); background: -ms-linear-gradient(top, #{_final_color1}, #{_final_color3}); background: linear-gradient(top bottom, #{_final_color1}, #{_final_color3}); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#{_final_color1}', endColorstr='#{_final_color3}',GradientType=0 );"
  _style2 = "text-shadow: 1px 1px 1px #{newval}; filter: dropshadow(color=#{newval}, offx=1px, offy=1px);"
  _style3 = "background-color: #{_final_color2};"
  _style4 = "border-bottom-color: #{_final_color5};"
  _style5 = "background-color: #{_final_color4};"
  return "#nav-content { #{_style1} } #nav #nav-content .sf-menu li a { #{_style2} } #nav #nav-content .sf-menu li ul { #{_style3} } #nav #nav-content .sf-menu li ul li { #{_style4} } #nav #nav-content .sf-menu li ul li a:hover, #nav #nav-content .sf-menu li ul li a:focus { #{_style5} }"
